import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function DeadlineBanner() {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // Saturday, March 21st, 2026 at 12:00 PM Eastern Time
    const deadline = new Date('2026-03-21T12:00:00-04:00').getTime();
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = deadline - now;
      if (distance < 0) {
        clearInterval(timer);
        return;
      }
      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(distance % (1000 * 60) / 1000)
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="sticky top-0 z-50 bg-red-950 border-b-2 border-red-600 py-2 px-3" data-id="element-608">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-2 md:gap-4" data-id="element-609">
        {/* Left side: Timer message and countdown */}
        <div className="flex items-center gap-2 md:gap-4 flex-1 min-w-0" data-id="element-610">
          <Clock className="w-4 h-4 md:w-5 md:h-5 text-red-500 animate-pulse flex-shrink-0" data-id="element-611" />
          <div className="flex flex-col md:flex-row md:items-center md:gap-4 min-w-0" data-id="element-612">
            {/* Mobile: Short message */}
            <p className="text-red-100 font-bold text-xs md:hidden leading-tight" data-id="element-613">
              LIVE Q&A IN
            </p>
            {/* Desktop: Full message */}
            <p className="hidden md:block text-red-100 font-bold text-base leading-tight" data-id="element-614">
              🔥 LIVE Q&A WITH BRENDEN & DR. ALI IN
            </p>
            <div className="flex items-center gap-1.5 text-red-100 text-xs md:text-sm" data-id="element-615">
              <span className="font-mono font-bold" data-id="element-616">
                {String(timeLeft.days).padStart(2, '0')}d
              </span>
              <span data-id="element-617">:</span>
              <span className="font-mono font-bold" data-id="element-618">
                {String(timeLeft.hours).padStart(2, '0')}h
              </span>
              <span data-id="element-619">:</span>
              <span className="font-mono font-bold" data-id="element-620">
                {String(timeLeft.minutes).padStart(2, '0')}m
              </span>
              <span data-id="element-621">:</span>
              <span className="font-mono font-bold" data-id="element-622">
                {String(timeLeft.seconds).padStart(2, '0')}s
              </span>
            </div>
            <p className="text-red-300/80 text-[10px] md:text-xs leading-tight mt-0.5 md:mt-0" data-id="element-623">
              Join before Saturday to attend live + get March's sleep
              optimization content
            </p>
          </div>
        </div>

        {/* Right side: CTA Button */}
        <button onClick={() => {
        const pricingSection = document.querySelector('[data-pricing-section]');
        if (pricingSection) {
          pricingSection.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }} className="flex-shrink-0 px-3 md:px-6 py-1.5 md:py-2 bg-amber-500 hover:bg-amber-400 text-black font-bold text-xs md:text-base rounded-lg transition-all duration-300 shadow-lg hover:shadow-amber-500/50 hover:scale-105 whitespace-nowrap cursor-pointer" data-id="element-624">
          Join Now
        </button>
      </div>
    </div>;
}